import { useState, useRef } from "react";

export default (start: number, end: number, onCompleted?: () => void) => {
  const [counter, setCounter] = useState(start);
  const [counterStatus, setCounterStatus] = useState(false);
  const holder = useRef({ intervalId: 0, counter }).current;

  holder.counter = counter;

  const startCounter = () => {
    resetCounter();

    setCounterStatus(true);
    //@ts-ignore
    holder.intervalId = setInterval(() => {
      const asc = end > start;
      const newCounterValue = asc ? holder.counter + 1 : holder.counter - 1;
      const mustStop = asc ? newCounterValue > end : newCounterValue < end;

      if (!mustStop) {
        setCounter(newCounterValue);
      } else {
        clearInterval(holder.intervalId);
        setCounterStatus(false);
        onCompleted && onCompleted();
      }
    }, 1000);
  };

  const stopCounter = () => {
    clearInterval(holder.intervalId);
    setCounterStatus(false);
    setCounter(end);
    onCompleted && onCompleted();
  };

  const resetCounter = () => {
    setCounter(start);
    clearInterval(holder.intervalId);
  };

  return { counter, counterStatus, startCounter, stopCounter };
};
